import {
  SUBSCRIPTION_PLAN_BUSINESS,
  SUBSCRIPTION_PLAN_ENTERPRISE,
  SUBSCRIPTION_PLAN_FREE,
  SUBSCRIPTION_PLAN_PREMIUM,
  SUBSCRIPTION_PLAN_STARTER
} from "../../constants/subscriptionPlans.js";

const plansLegend = [SUBSCRIPTION_PLAN_FREE, SUBSCRIPTION_PLAN_STARTER, SUBSCRIPTION_PLAN_PREMIUM, SUBSCRIPTION_PLAN_BUSINESS, SUBSCRIPTION_PLAN_ENTERPRISE];
export const sortedPlans = (data) => {
  return data.sort((a, b) => {
    return plansLegend.indexOf(a.productsLimit) - plansLegend.indexOf(b.productsLimit);
  });
};